import { render, staticRenderFns } from "./RecipeInvoice.vue?vue&type=template&id=772d4dc8&scoped=true"
import script from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecipeInvoice.vue?vue&type=style&index=0&id=772d4dc8&prod&scoped=true&lang=css"
import style1 from "./RecipeInvoice.vue?vue&type=style&index=1&id=772d4dc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d4dc8",
  null
  
)

export default component.exports